<h4>Bank Transactions</h4>
<div>
  <table class="table" *ngIf="xeroTrackedItems.length > 0">
    <thead>
      <tr>
        <th style="width: 10%">STATUS</th>
        <th style="width: 8%">CONTACT</th>
        <th style="width: 8%">DATE</th>
        <th style="width: 10%; text-align: right;">AMOUNT</th>
        <th style="width: 8%">COMMENTS</th>
        <th style="width: 19%">
          ACCOUNT
        </th>
        <th style="width: 18%">ACTIONS</th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let tracked_item of xeroTrackedItems"
        (click)="selectTrackedItem(tracked_item)"
        [ngClass]="{ selected: tracked_item.selected }"
      >
        <td>
          <div
            class="status-badge"
            [ngClass]="{
              open: tracked_item.answer_status == 'open',
              answered: tracked_item.answer_status == 'answered',
              closed: tracked_item.answer_status == 'closed'
            }"
          >
            {{ tracked_item.answer_status }}
          </div>
        </td>
        <td>
          <a href="https://go.xero.com/Contacts/View/{{ tracked_item.integration_data.transaction_body.Contact.ContactID }}"
             target="_blank">
            {{ tracked_item.integration_data.transaction_body.Contact.Name }}
            <i class="tio-open_in_new"></i>
          </a>
        </td>
        <td>
          {{ tracked_item.integration_data.transaction_body.DateString | amDateFormat : "ll" }}
        </td>
        <td style="text-align: right; font-variant-numeric: tabular-nums;">
          <span
            *ngIf="
            tracked_item.integration_data.transaction_body.Total.toString().includes('.')
            "
            >${{ tracked_item.integration_data.transaction_body.Total }}</span
          >
          <span
            *ngIf="
              !tracked_item.integration_data.transaction_body.Total.toString().includes('.')
            "
            >${{ tracked_item.integration_data.transaction_body.Total }}.00</span
          >
        </td>
        <td>
          <div
            class="client-task-pill"
            tooltip="{{ tracked_item.comments.length }} comments"
          >
            <svg
              *ngIf="tracked_item.comments.length == 0"
              width="18"
              height="19"
              viewBox="0 0 18 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.75 11.75C15.75 12.1478 15.592 12.5294 15.3107 12.8107C15.0294 13.092 14.6478 13.25 14.25 13.25H5.25L2.25 16.25V4.25C2.25 3.85218 2.40804 3.47064 2.68934 3.18934C2.97064 2.90804 3.35218 2.75 3.75 2.75H14.25C14.6478 2.75 15.0294 2.90804 15.3107 3.18934C15.592 3.47064 15.75 3.85218 15.75 4.25V11.75Z"
                stroke="#485364"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <svg
              *ngIf="tracked_item.comments.length > 0"
              width="18"
              height="19"
              viewBox="0 0 18 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.75 11.75C15.75 12.1478 15.592 12.5294 15.3107 12.8107C15.0294 13.092 14.6478 13.25 14.25 13.25H5.25L2.25 16.25V4.25C2.25 3.85218 2.40804 3.47064 2.68934 3.18934C2.97064 2.90804 3.35218 2.75 3.75 2.75H14.25C14.6478 2.75 15.0294 2.90804 15.3107 3.18934C15.592 3.47064 15.75 3.85218 15.75 4.25V11.75Z"
                fill="#0075FF"
                stroke="#0075FF"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span class="comments-counter">{{
              tracked_item.comments.length
            }}</span>
          </div>
        </td>
        <td class="qbo-cap-dropdown">
          <input
          tooltip="{{ tracked_item.selectedAcc }}"
          [(ngModel)]="tracked_item.selectedAcc"
          [typeahead]="availableAccounts"
          typeaheadOptionField="Name"
          (typeaheadOnSelect)="selectAccount($event, tracked_item)"
          [typeaheadOptionsLimit]="9999"
          [typeaheadMinLength]="0"
          placeholder="Choose Account"
          class="form-control chevron"
          [typeaheadItemTemplate]="customItemTemplate"
        />
        </td>
        <td style="white-space: nowrap">
          <button
            class="btn btn-primary"
            *ngIf="tracked_item.answered == false"
            (click)="submitAnswer(tracked_item)"
            [disabled]="tracked_item.selectedAcc == null || tracked_item.selectedAcc == ''"
          >
            Submit
          </button>
          <button
            class="btn btn-default justify-content-center"
            style="margin-right: 8px"
            *ngIf="
              tracked_item.answered == true &&
              (tracked_item.satisfied == false ||
                tracked_item.satisfied == null) &&
              data.user_type == 1
            "
            (click)="answerTrackedItem(tracked_item, false)"
          >
            Re-open
          </button>
          <button
            class="btn btn-success justify-content-center"
            *ngIf="
              tracked_item.answered == true &&
              (tracked_item.satisfied == false ||
                tracked_item.satisfied == null) &&
              data.user_type == 1
            "
            style="margin-right: 8px"
            (click)="goToXero(tracked_item.integration_data.transaction_id)"
          >
            Go to Xero
          </button>

          <button
            class="btn btn-default"
            *ngIf="
              tracked_item.answered == true &&
              (tracked_item.satisfied == false ||
                tracked_item.satisfied == null) &&
              data.user_type == 1
            "
            (click)="answerTrackedItem(tracked_item, true)"
          >
            Close
          </button>
          <a
            *ngIf="data.user_type == 1"
            class="btn btn-default btn-open-xero"
            target="_blank"
            rel="noreferrer noopener"
            href="https://go.xero.com/Bank/ViewTransaction.aspx?bankTransactionID={{
              tracked_item?.integration_data?.transaction_id
            }}"
            tooltip="View in Xero"
          >
            <i class="tio-open_in_new"></i>
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<ng-template #customItemTemplate let-model="item" let-index="index">
  <div class="xero-accounts-item">
    <div class="name" title="{{ model.path }}">{{ model.Name }}</div>
    <div class="category">{{ model.Code }} {{ model.BankAccountType ? '|' : '' }} {{ model.BankAccountType }}</div>
  </div>
</ng-template>
